export const LabelNew = () => {
  return <label className="nj-label-new">NEW</label>;
};
